import Paginate from 'vuejs-paginate'
import swal from 'sweetalert'
import Status from '@/components/status-user'

export default {
  name: 'list-user',
  components: {Paginate, Status},
  props: [],
  data () {
    return {
      normalizer (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      per_page: 20,
      status: '',
      organization_id: null,
      sort: 'desc',
      search: '',
      group: '',
      loading: true
    }
  },
  computed: {
    users () {
      return this.$store.getters['User/users']
    },
    last_page () {
      return this.$store.getters['User/last_page']
    },
    total () {
      return this.$store.getters['User/total']
    },
    organizations () {
      return this.$store.getters['Organization/getOrganization']
    },
    options () {
      return this.$store.getters['Status/getStatusUser']
    },
    groups () {
      return this.$store.getters['Group/getListGroup']
    }
  },
  mounted () {
    if (this.$route.query.group_id) {
      this.group = this.$route.query.group_id
    }
    if (this.$route.query.organization_id) {
      this.organization_id = this.$route.query.organization_id
    }
  
    Promise.all([
      this.$store.dispatch('User/getData', { page: 1, per_page: this.per_page, search: this.search, sort: this.sort, status: this.status, organization_id: this.organization_id, group_id: this.group }),
      this.$store.dispatch('Organization/getData', {page: 1, per_page: 'all'}),
      this.$store.dispatch('Status/getListStatus'),
      this.$store.dispatch('Group/getListGroup', {page: 1, per_page: 'all'})
    ]).then(() => {
      
      this.loading = false
    }).catch(errors => {
      console.log(errors)
      
      this.loading = false
    })
  },
  methods: {
    addUser(){
      this.$router.push('create')
    },
    changePage (pageNum) {
    
      this.$store.dispatch('User/getData', { page: pageNum, per_page: this.per_page, search: this.search, sort: this.sort, status: this.status, organization_id: this.organization_id, group_id: this.group })
        .then(() => {
          
        })
    },
    changeTotal () {
    
      this.$store.dispatch('User/getData', { page: 1, per_page: this.per_page, search: this.search, sort: this.sort, status: this.status, organization_id: this.organization_id, group_id: this.group })
        .then(() => {
          
        })
    },
    filter () {
    
      this.$store.dispatch('User/getData', { page: 1, per_page: this.per_page, search: this.search, sort: this.sort, status: this.status, organization_id: this.organization_id, group_id: this.group })
        .then(() => {
          
        })
    },
    edit (user) {
      this.$router.push(user.id + '/edit')
    },
    destroy (user) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
          
            this.$store.dispatch('User/destroyUser', {
              user
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              
            }).catch(errors => {
              
            })
          }
        })
    },
    active (user) {
    
      this.$store.dispatch('User/activeUser', {
        user
      }).then(res => {
        user.status = res.status
        
      }).catch(errors => {
        
      })
    },
    deactivate (user) {
    
      this.$store.dispatch('User/deactivateUser', {
        user
      }).then(res => {
        user.status = res.status
        
      }).catch(errors => {
        
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/user/list/list.component.js